import { createReducer, on } from '@ngrx/store';
import * as ChannellistActions from './Channellist.action';

export interface ChannelState {
  channels: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: ChannelState = {
  channels: [],
  loading: false,
  error: null,
};

export const channellistReducer = createReducer(
  initialState,
  on(ChannellistActions.loadChannels, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ChannellistActions.loadChannelsSuccess, (state, { channels }) => ({
    ...state,
    channels,
    loading: false,
  })),
  on(ChannellistActions.loadChannelsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
